import React from 'react'
import PropTypes from 'prop-types'
import { useFeature } from '@pcln/feature-components'
import { ResponsiveChangeSearchHeader } from '@pcln/fly-search-header-react'

const formatPassengers = passengers => ({
  lapInfants: passengers?.infants ?? 0,
  ...passengers,
})

const formatRtSlices = slices => {
  const slice1 = slices?.[0]?.split?.('-')
  const slice2 = slices?.[1]?.split?.('-')
  return [
    {
      origAirportCode: slice1?.[0],
      destAirportCode: slice1?.[1],
      date: slice1?.[2],
      returnDate: slice2?.[2],
    },
  ]
}

const formatSlices = (slices, tripType) =>
  tripType === 'RT'
    ? formatRtSlices(slices)
    : slices.map(slice => {
        const sliceParts = slice?.split?.('-')
        return {
          origAirportCode: sliceParts?.[0],
          destAirportCode: sliceParts?.[1],
          date: sliceParts?.[2],
        }
      })

const ResponsiveChangeSearchHeaderWrapper = ({
  defaultTripSlices = [],
  defaultTripType = 'RT',
  defaultPassengers = { adults: 1 },
  ...props
}) => {
  const subLabelMap = {
    adults: '(ages 18 and up)',
    youths: '(ages 12-17)',
    children: '(ages 2-11)',
    lapInfants: '(under 2)',
  }
  return (
    <ResponsiveChangeSearchHeader
      defaultPassengers={formatPassengers(defaultPassengers)}
      defaultTripSlices={formatSlices(defaultTripSlices, defaultTripType)}
      defaultTripType={defaultTripType}
      subLabelMap={useFeature('flights.useMultipax') ? subLabelMap : null}
      lapInfantLabel={
        useFeature('flights.useMultipax') ? 'Infants on lap' : null
      }
      {...props}
    />
  )
}

ResponsiveChangeSearchHeaderWrapper.propTypes = {
  defaultTripType: PropTypes.string,
  defaultCabinClass: PropTypes.string,
  defaultPassengers: PropTypes.object,
  defaultTripSlices: PropTypes.array,
  defaultAirports: PropTypes.object,
  isWhiteLabel: PropTypes.bool,
  pclnExpt: PropTypes.any,
  urlRoot: PropTypes.string,
  queryParams: PropTypes.object,
  filterOnClick: PropTypes.func,
  displayFlexibleDatesCheckbox: PropTypes.func,
}

export { ResponsiveChangeSearchHeaderWrapper }
